import { Navigate, createFileRoute } from "@tanstack/react-router";
import { resolveCurrentOwnerCustomerId } from "@/lib/customer-resolution";

export const Route = createFileRoute("/app/")({
  component: AppEntry,
});

function AppEntry() {
  return <Navigate to="/app/$customerId" params={{ customerId: resolveCurrentOwnerCustomerId() }} replace />;
}
